// Copyright (c) 2025 WSO2 LLC. (https://www.wso2.com).
//
// WSO2 LLC. licenses this file to you under the Apache License,
// Version 2.0 (the "License"); you may not use this file except
// in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License. 

export const SnackMessage = {
  success: {
    addMeetings: "Successfully created the Meeting",
    deleteMeeting: "Successfully deleted the Meeting",
  },
  error: {
    addMeetings: "Unable to create the Meeting",
    deleteMeeting: "Unable to delete the Meeting",
    fetchPrivileges: "Failed to fetch Privileges",
    insufficientPrivileges: "Insufficient Privileges",
    fetchMeetings: "Unable to retrieve list of Meetings",
    fetchContacts: "Unable to retrieve list of Contacts",
    fetchEmployees: "Unable to retrieve list of Employees",
    fetchCustomers: "Unable to retrieve list of Customers",
    fetchRegions: "Unable to retrieve list of Regions",
    fetchAttachments: "Unable to retrieve list of Attachments",
    fetchMeetingTypes: "Unable to retrieve list of Meeting Types",
    fetchAppConfigMessage: "Unable to retrieve app configurations",
    fetchRecordingStatsMessage:"Unable to retrieve Recording Stats",
  },
  warning: {},
};
